import React, { useContext } from 'react';

import { ManualAddressForm as ManualAddressFormComponent } from '../../../../components/ui/Inputs/ManualAddressForm';
import { MlifeAccountSetupContext } from '../MlifeAccountSetupContext';

export function ManualAddressForm() {
  const {
    creditAccount,
    bindAddress,
    bindAddress2,
    bindCity,
    bindCountry,
    bindCustomState,
    resetCustomState,
    bindState,
    resetState,
    bindZip,
    invalidFields,
    removeInvalidField,
    setInvalidField,
    isLoading,
  } = useContext(MlifeAccountSetupContext);

  return (
    <ManualAddressFormComponent
      {...{
        bindAddress,
        bindAddress2,
        bindCity,
        bindCountry,
        bindCustomState,
        resetCustomState,
        bindState,
        resetState,
        bindZip,
        invalidFields,
        removeInvalidField,
        setInvalidField,
        isLoading,
        disabled: creditAccount,
      }}
    />
  );
}
